import {NumberFormats} from '@/util/constants'

var testValidity = function (value, re) {
  return value.length < 1 ? null : re.test(value)
}

var toBase = function (number, oldBase, newBase) {
  return parseInt(number, oldBase).toString(newBase)
}

var parseable = function (value) {
  return value.substring(1)
}

export const fillSignedBinary = function (value, length) {
  var bits = value.toString(2)
  return length < bits.length ? bits.substring(bits.length - length) : (value >= 0 ? '0' : '1').repeat(length - bits.length) + bits
}

export const fillBinary = function (value, length) {
  var bits = value.toString(2)
  return length < bits.length ? bits.substring(bits.length - length) : '0'.repeat(length - bits.length) + bits
}

export const Numbers = Object.freeze({
  data () {
    return {
      binaryValue: '',
      decimalValue: '',
      hexadecimalValue: ''
    }
  },
  computed: {
    binaryValid: function () {
      return testValidity(this.binaryValue, NumberFormats.BINARY_RE)
    },
    decimalValid: function () {
      return testValidity(this.decimalValue, NumberFormats.DECIMAL_RE)
    },
    hexadecimalValid: function () {
      return testValidity(this.hexadecimalValue, NumberFormats.HEXADECIMAL_RE)
    },
    parseableBinary: function () {
      return parseable(this.binaryValue)
    },
    parseableDecimal: function () {
      return parseable(this.decimalValue)
    },
    parseableHexadecimal: function () {
      return parseable(this.hexadecimalValue)
    },
    binaryInt: function () {
      return parseInt(this.parseableBinary, 2)
    },
    signedBinaryInt: function () {
      return ('0b' + this.parseableBinary[0].repeat(32 - this.parseableBinary.length) + this.parseableBinary) | 0
    },
    decimalInt: function () {
      return parseInt(this.parseableDecimal)
    },
    hexadecimalInt: function () {
      return parseInt(this.parseableHexadecimal, 16)
    }
  },
  methods: {
    toBinary: function (number, base) {
      return toBase(number, base, 2)
    },
    toDecimal: function (number, base) {
      return toBase(number, base, 10)
    },
    toHexadecimal: function (number, base) {
      return toBase(number, base, 16)
    }
  }
})



// WEBPACK FOOTER //
// ./src/util/numbers.js